/*
 *
 * Form
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Field,
  reduxForm,
  getFormSyncErrors,
  formValueSelector,
} from 'redux-form';
import {
  StyledForm,
  FormButtonGroup,
  Agree,
  Demo
} from './styledComponents';
import validate from './validate';

import Button from 'components/Button';
import InputField from 'components/InputField';
import CheckboxField from 'components/CheckboxField';

const Form = ({
  handleSubmit,
  syncErrors,
  openInvalidEmailModal,
  openInvalidPasswordModal,
}) => {
  return (
  <StyledForm onSubmit={handleSubmit}>
    <Field
      name='email'
      type='text'
      component={InputField}
      label='Email Address'
      placeholder='email@example.com'
    />
    <Field
      name='password'
      type='password'
      component={InputField}
      label='Password'
      placeholder='••••••••••••'
      onBlur={(e) => e.preventDefault()}
      isSignup
    />
    <Agree>
    By clicking Create Account, I agree to Movebooth's <Link
       to='https://movebooth.com/terms' target="_blank" rel="noreferrer noopener"> Terms of Service &amp; Privacy Policy.</Link>
    </Agree>
      <FormButtonGroup>
        {!!syncErrors && (!!syncErrors.email || !!syncErrors.password) 
          ?
              <Button
                type='submit'
                onClick={
                  !!syncErrors.email
                    ? () => openInvalidEmailModal()
                    : () => openInvalidPasswordModal({ ...syncErrors.password })
                }>
                Create Account
              </Button>
          :
              <Button type='submit'>Create Account</Button>
        }
        <Demo to='/#'>
          or see a demo first
        </Demo>
      </FormButtonGroup>
  </StyledForm>
);}
const selector = formValueSelector('signUp');
export default reduxForm({ form: 'signUp', validate, touchOnBlur: true })(connect(
  state => ({
    syncErrors: getFormSyncErrors('signUp')(state),
  })
)(Form));



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/Form.js